import { Menu, PackageSearch, ShoppingCart, UserRound, X } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { api } from "../api";
import { useCart } from "../context/CartContext";
import type { User } from "../types";

export function Layout() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const { itemCount } = useCart();
  const loadUser = useCallback(() => { api<{ user: User | null }>("/api/auth/me").then(result => setUser(result.user)).catch(() => setUser(null)); }, []);

  useEffect(() => {
    loadUser(); window.addEventListener("portal-auth-changed", loadUser);
    return () => window.removeEventListener("portal-auth-changed", loadUser);
  }, [loadUser]);

  return <div className="app-shell">
    <header className="site-header">
      <Link to="/" className="brand" aria-label="Holyman - início"><img className="brand-logo" src="https://www.holymanpecas.com.br/img/logo/logo.png" alt="Holyman" /><span><strong>HOLYMAN</strong><small>Catálogo Automotivo</small></span></Link>
      <button className="menu-toggle" onClick={() => setOpen(value => !value)} aria-label="Abrir menu">{open ? <X /> : <Menu />}</button>
      <nav className={open ? "main-nav open" : "main-nav"}>
        <NavLink to="/catalogo" onClick={() => setOpen(false)}><PackageSearch size={18} /> Produtos</NavLink>
        <NavLink to="/carrinho" onClick={() => setOpen(false)} className="cart-nav-link"><ShoppingCart size={18} /> Carrinho{itemCount > 0 && <span className="cart-count">{itemCount}</span>}</NavLink>
        <NavLink to={user ? "/portal" : "/entrar"} onClick={() => setOpen(false)}><UserRound size={18} /> {user ? user.name.split(" ")[0] : "Área do cliente"}</NavLink>
      </nav>
    </header>
    <main><Outlet /></main>
    <footer className="site-footer"><div className="footer-brand"><Link to="/" aria-label="Holyman - início"><img className="footer-brand-logo" src="https://www.holymanpecas.com.br/img/logo/logo.png" alt="Holyman" /></Link><div><strong>Holyman Indústria Automotiva</strong><p>Produtos desenvolvidos para o mercado de reposição automotiva.</p></div></div><div className="footer-note">Pedidos sujeitos à análise comercial e disponibilidade.</div></footer>
  </div>;
}
